module.exports = __webpack_public_path__ + "static/media/view5.be9cef6c.jpg";